import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import Confirm from 'components/Utils/Modal/Confirm'
import Button from 'components/base/Button'

class BulkContromItem extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    onAction: PropTypes.func.isRequired,
    noteIds: PropTypes.array.isRequired,
  }

  state = {
    confirm: false,
  }

  onClickShowConfirm = event => {
    event.preventDefault()
    this.showConfirm()
  }

  onClickAction = event => {
    event.preventDefault()
    this.props.onAction(this.props.item)
  }

  onClickCancel = event => {
    event.preventDefault()
    this.hideConfirm()
  }

  showConfirm = () => {
    this.setState({ confirm: true })
  }

  hideConfirm = event => {
    this.setState({ confirm: false })
  }

  render() {
    return (
      <Fragment>
        {this.state.confirm && (
          <Confirm
            show
            onConfirm={this.onClickAction}
            onCancel={this.onClickCancel}
          >
            {this.props.item.confirm(this.props)}
          </Confirm>
        )}

        <Button.Secondary
          className="margin-horizontal-small"
          onClick={
            this.props.item.confirm
              ? this.onClickShowConfirm
              : this.onClickAction
          }
        >
          <div className="shade-20 padding-right-normal">
            {React.createElement(this.props.item.icon, { size: 16 })}
          </div>
          {this.props.item.title}
        </Button.Secondary>
      </Fragment>
    )
  }
}

export default BulkContromItem
